export default __webpack_public_path__ + "static/media/eefb1f301146aef060ae5854c3daa078.32f2def1.svg";